import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const AdminRoute = ({ component: Component }) => {
  const { user } = useAuth();

  if (user === undefined) {
      return <div>Chargement...</div>; // Affiche un loader en attendant que l'état user soit récupéré
  }

  return user && user.role === "ADMIN" ? <Component /> : <Navigate to="/" />;
};

export default AdminRoute;